module.exports = __webpack_public_path__ + "static/commercial-trucking-unladen-liability-insurance-147a439e1cb4bf82efb13f7a0ba7131c.svg";